import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { ForgotPasswordService } from 'src/app/share/services/forgot-password/forgot-password.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  errorMessage: string | undefined;
  showForm1: boolean = true;
  showForm2: boolean = false;
  showForm3: boolean = false;
  forgotpwdForm!: FormGroup;
  registeredMail: string = '';
  registerForm2!: FormGroup;
  hide: boolean = true;
  hide1: boolean = true;
  otpvalue: any;
  passwordValue: any;
  message: any;
  isLoading  : boolean= false;
  loader : boolean = false;


  constructor(
    private readonly fb: FormBuilder,
    private readonly forgotPasswordService: ForgotPasswordService
  ){}
  ngOnInit(): void {
    this.initilizeForgotPwdForm();
    this.initilizeRegisterForm2();
  }

  initilizeForgotPwdForm(): void {
    this.forgotpwdForm = this.fb.group({
      phoneNumber: ['',  [
        Validators.required,
        Validators.pattern(RegExpPatterns.MobilePattern),
      ],],
    });
    this.registeredMail = '';
  }
  
  initilizeRegisterForm2(): void {
    this.registerForm2 = this.fb.group(
      {
        otp: ['', [Validators.required]],
        password: [
          '',
          [
            Validators.required,
            Validators.pattern(RegExpPatterns.PasswordPattern),
          ],
        ],
        repassword: ['', [Validators.required]],
      },
      {
        validators: this.passwordsMatchValidatorForForm2,
      } as any
    );
  }

  passwordsMatchValidatorForForm2(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const repassword = formGroup.get('repassword')?.value;
    if (password === repassword) {
      formGroup.get('repassword')?.setErrors(null);
    } else {
      formGroup.get('repassword')?.setErrors({ passwordsMismatch: true });
    }
  }

  onForgotpwd() {
    this.isLoading = true;
    this.forgotPasswordService.forgotPassword(this.forgotpwdForm?.value).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.registeredMail = this.forgotpwdForm.controls['phoneNumber']?.value;
        this.showForm1 = false;
        this.showForm2 = true;
      },
      error: (error) => {
        this.message = error?.error?.error?.message;
        this.isLoading = false;
      }
    });
  }

  resendOtp() {
    this.loader = true;
    this.forgotPasswordService.forgotPassword(this.forgotpwdForm.value).subscribe({
      next: (res) => {
        this.loader = false;
        this.registeredMail =
        this.forgotpwdForm.controls?.['phoneNumber'].value;
      },
      error: (error) => {
        this.message = error?.error?.error?.message;
        this.loader = false;
      }
    });
  }

  onVerify2() {
    this.isLoading = true;
    this.otpvalue = this.registerForm2?.controls['otp'].value;
    this.passwordValue = this.registerForm2?.controls['password'].value;
    const payload = {
      phoneNumber: this.registeredMail,
      otp: this.otpvalue,
      password: this.passwordValue,
    };
    this.forgotPasswordService.changePassword(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.showForm2 = false;
        this.showForm3 = true;
      },
      error: (error) => {
        this.message = error?.error?.error?.message;
        this.isLoading = false;
      }
    });
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.forgotpwdForm.controls['phoneNumber'].setValue(inputElement.value);
    }
  }

  input(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 6) {
      inputElement.value = inputElement.value.slice(0, 6);
      this.registerForm2.controls['otp'].setValue(inputElement.value);
    }
  }

  protected readonly faEye = faEye;
  protected readonly faEyeSlash = faEyeSlash;
}
